/* 
Object:         Occupancy Region Map
Description:    Logic and events for the module Occupancy Region Map
Used in:        Occupancy Region Map
*/

import * as appsettings from "../appsettings";
import * as occupancyRegion from "./occupancyRegion";
import { TimeSelectionEnum } from "../enums/timeSelectionEnum";


let bounds: google.maps.LatLngBounds;
let map: google.maps.Map;
let occupancyRegionHours = {};

// Local array of markers
let markers = [];

// Local array of popup windows
let infoWindows = [];

// counter number of popups
let counterPopupOpen = 0;

/**
* setLoadingContent
* @param {InfoWindowWithMarker} infowindow
*/
function setLoadingContent(infowindow: InfoWindowWithMarker): void {
    infowindow.setContent("<div style=\"width: 15px; height: 15px;\" class=\"k-i-loading\"> </div>");
}

/**
* get marker icons
* @param {any} getMarkerIcon
*/
function getMarkerIcon(occupancy: number): {
    url: string,
    size: google.maps.Size,
    origin: google.maps.Point,
    anchor: google.maps.Point,
    scaledSize: google.maps.Size
} {
    if (occupancy < 100) {
        const pinImage = {
            url: appsettings.getUrl("images/Maps/icon_nooccupancy.png"),
            size: new google.maps.Size(43, 43),         // size
            origin: new google.maps.Point(0, 0),        // origin
            anchor: new google.maps.Point(21, 21),      // anchor
            scaledSize: new google.maps.Size(43, 43)    // scaled size
        };
        return pinImage;

    } else if (occupancy > 100) {

        const image = {
            url: appsettings.getUrl("images/Maps/icon_occupancy.png"),
            size: new google.maps.Size(43, 43),         // size
            scaledSize: new google.maps.Size(43, 43),   // origin
            origin: new google.maps.Point(0, 0),        // the origin for this image is (0, 0).
            anchor: new google.maps.Point(21, 21)       // scaled size
        };
        return image;

    } else {
        const yellow_image = {
            url: appsettings.getUrl("images/Maps/icon_min_occupancy.png"),
            size: new google.maps.Size(43, 43),         // size
            scaledSize: new google.maps.Size(43, 43),   // origin
            origin: new google.maps.Point(0, 0),        // the origin for this image is (0, 0).
            anchor: new google.maps.Point(21, 21)       // scaled size
        };
        return yellow_image;
    }
}

function addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}



/**
 * initialize overview with all the events bound to the buttons.
 */
export function initialize(): void {
    occupancyRegionHours = {};

    $("#container-occupancymap").load(appsettings.getUrl("occupancyRegionMap/OccupancyMap?timeSelection=0"));
}

/**
 * delete a item
 */
export function deleteItem(): void { }

/**
 * onChangeTimeInterval
 */
export function onChangeTimeInterval(): void {
    const timeSelection = $('#TimeSelectionId').val();
    $("#container-occupancymap").load(appsettings.getUrl("occupancyRegionMap/OccupancyMap?timeSelection=" + timeSelection));
}

/**
 * onChangeTimeInterval
 * @param {any} element
 * @param {any} timeSelection
 * @param {any} nodeId
 */
export function refreshOccupancy(element: HTMLButtonElement, timeSelection: number, nodeId: number): void {

    $('#buttonDaysOccupancy_' + nodeId + ' button').removeClass('bttnActive');
    $(element).addClass('bttnActive');
    $("#contentOccupancy" + nodeId).html("<div style=\"width: 15px; height: 15px;\" class=\"k-i-loading\"> </div>");

    const currentDate = new Date(new Date().toDateString());
    const selectedDate = addDays(currentDate, timeSelection);
    occupancyRegion.setPresentationDate(selectedDate);

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("occupancyRegion/OccupancyRegionNodesWNodeID"),
        data: {
            nodeId: nodeId,
            selectedDate: selectedDate.toDateString()
        },
        success: function (data) {
            $('#contentOccupancy' + nodeId).html(data);
            occupancyRegion.loadNotOccupiedGroups();
        }
    });
}

/**
 * initializeMap
 * @param {int} nodeId
 * @param {TimeSelectionEnum} timeSelection
 */
export function initializeMap(nodeId: number, timeSelection: TimeSelectionEnum): void {

    bounds = new google.maps.LatLngBounds();

    map = new google.maps.Map(document.getElementById('mapview'), {
        center: { lat: 51.944710, lng: 5.336113 },
        zoom: 8,
        mapId: "map"
    });

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("occupancyRegionMap/GetMarkers"),
        data: {
            nodeId: nodeId,
            timeSelection: timeSelection
        },
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (result) {

            for (let i = 0; i < result.length; i++) {
                if (result[i].Latitude != null && result[i].Longitude != null) {

                    const marker = new google.maps.marker.AdvancedMarkerElement({
                        position: { lat: result[i].Latitude, lng: result[i].Longitude },
                        map: map,
                        title: result[i].NodeName + '_' + result[i].NodeId,
                    });

                    marker.nodeId = result[i].NodeId;

                    const icon = document.createElement('img');
                    icon.src = getMarkerIcon(result[i].MinOccupancy).url;
                    marker.append(icon);

                    marker.MinOccupancy = result[i].MinOccupancy;
                    marker.OccupancyToday = result[i].OccupancyToday;
                    marker.OccupancyDayOne = result[i].OccupancyDayOne;
                    marker.OccupancyDayTwo = result[i].OccupancyDayTwo;
                    marker.OccupancyDayThree = result[i].OccupancyDayThree;

                    if (marker.position) {
                        bounds.extend(marker.position);
                    }

                    marker.addListener('click', function () {
                        counterPopupOpen++;
                        const infowindow = new google.maps.InfoWindow() as InfoWindowWithMarker;
                        infoWindows.push(infowindow);
                        const markerMouserClick = this;//add this to local scope
                        infowindow.marker = markerMouserClick;
                        markerMouserClick.infowindow = infowindow;

                        google.maps.event.addListener(infowindow, 'closeclick', function () {
                            counterPopupOpen--;
                        });

                        setLoadingContent(infowindow);
                        infowindow.open(map, markerMouserClick);

                        const currentDate = new Date(new Date().toDateString());

                        // Post Data
                        $.ajax({
                            type: "POST",
                            url: appsettings.getUrl("occupancyRegion/OccupancyRegionNodesWNodeID"),
                            data: {
                                nodeId: parseInt(markerMouserClick.title.split('_')[1]),
                                selectedDate: currentDate.toDateString()
                            },
                            success: function (data) {
                                infowindow.setContent("<div id='contentOccupancy" + markerMouserClick.title.split('_')[1] + "' style='width: 500px'></div> <div id='buttonDaysOccupancy_" + markerMouserClick.title.split('_')[1] + "'></div>");
                                $('#contentOccupancy' + markerMouserClick.title.split('_')[1]).html(data);

                                const currentDate = new Date(new Date().toDateString());
                                const currentDateDayOne = addDays(currentDate, 1);
                                const currentDateDayTwo = addDays(currentDate, 2);
                                const currentDateDayThree = addDays(currentDate, 3);

                                $('#buttonDaysOccupancy_' + markerMouserClick.nodeId).html(
                                    "<button id='bttn_today_" + markerMouserClick.nodeId + "' onclick='PreCom.Modules.occupancyRegionMap.refreshOccupancy(this, 0, " + markerMouserClick.nodeId + " )'>" + currentDate.toLocaleDateString() + "</button> " +
                                    "<button id='bttn_dayone_" + markerMouserClick.nodeId + "' onclick='PreCom.Modules.occupancyRegionMap.refreshOccupancy(this, 1, " + markerMouserClick.nodeId + " )'>" + currentDateDayOne.toLocaleDateString() + "</button> " +
                                    "<button id='bttn_daytwo_" + markerMouserClick.nodeId + "' onclick='PreCom.Modules.occupancyRegionMap.refreshOccupancy(this, 2, " + markerMouserClick.nodeId + " )'>" + currentDateDayTwo.toLocaleDateString() + "</button> " +
                                    "<button id='bttn_daythree_" + markerMouserClick.nodeId + "' onclick='PreCom.Modules.occupancyRegionMap.refreshOccupancy(this, 3, " + markerMouserClick.nodeId + " )'>" + currentDateDayThree.toLocaleDateString() + "</button> ");

                                if (markerMouserClick.OccupancyToday < 100) {
                                    if (markerMouserClick.OccupancyToday == -10000) {
                                        $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                    } else {
                                        $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'red');
                                    }
                                } else if (markerMouserClick.OccupancyToday > 100) {
                                    $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'green');
                                } else {
                                    $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                }

                                if (markerMouserClick.OccupancyDayOne < 100) {
                                    if (markerMouserClick.OccupancyDayOne == -10000) {
                                        $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                    } else {
                                        $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'red');
                                    }
                                } else if (markerMouserClick.OccupancyDayOne > 100) {
                                    $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'green');
                                } else {
                                    $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                }

                                if (markerMouserClick.OccupancyDayTwo < 100) {
                                    if (markerMouserClick.OccupancyDayTwo == -10000) {
                                        $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                    } else {
                                        $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'red');
                                    }
                                } else if (markerMouserClick.OccupancyDayTwo > 100) {
                                    $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'green');
                                } else {
                                    $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                }

                                if (markerMouserClick.OccupancyDayThree < 100) {
                                    if (markerMouserClick.OccupancyDayThree == -10000) {
                                        $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                    } else {
                                        $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'red');
                                    }
                                } else if (markerMouserClick.OccupancyDayThree > 100) {
                                    $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'green');
                                } else {
                                    $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                }

                                occupancyRegion.loadNotOccupiedGroups();
                            }
                        });
                    });

                    markers.push(marker);
                }
            }

            if (!bounds.isEmpty()) {
                map.fitBounds(bounds);
            }

            $('#ProgressMap').remove();
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error("FOUT !!!!", textStatus, errorThrown);            // TODO: error handling
        }
    });
}
